import React from 'react';
import { SafetyOutlined } from '@ant-design/icons';
import { ShieldOffIcon } from '../Icons';

export function getCancellationType(highlights = [], highlights2 = []) {
  const allHighlights = highlights || [];

  const checkedHighlights = allHighlights.filter(
    (highlight) => highlight.check
  );

  const hasFreeCancellation = checkedHighlights.some(
    (highlight) => highlight.type === 'facility_free_cancellation'
  );

  const cancellationValue = (highlights2 || []).find(
    (highlight) => highlight.structfield_key === 'cancellation'
  )?.structfield_value;

  const normalizedCancellation = (cancellationValue || '')
    .toLowerCase()
    .replace(/[-–—]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

  const isFreeUntilCheckIn =
    normalizedCancellation.includes('full refund up to time of check in') ||
    normalizedCancellation.includes('full refund up to calendar day of check in');

  const cancellationTypeFromHighlights2 =
    normalizedCancellation.includes('non refundable') ||
      normalizedCancellation.includes('non-refundable')
      ? 'non-refundable'
      : normalizedCancellation.includes('partial refund')
        ? 'partial'
        : isFreeUntilCheckIn
          ? 'free'
          : normalizedCancellation.includes('full refund')
            ? 'none'
            : null;

  const cancellationTypeFromHighlights =
    allHighlights.length > 1
      ? hasFreeCancellation
        ? 'free'
        : ''
      : null;

  return cancellationTypeFromHighlights2 || cancellationTypeFromHighlights;
}

export default function CancellationInformation({
  highlights,
  highlights2,
  facility,
  extraClass = '',
  size = null,
  ...props
}) {
  const cancellationType = getCancellationType(highlights, highlights2);

  const lineClass =
    'inline-flex items-center gap-1.5 whitespace-nowrap text-[#1E2A38]';

  return (
    <div className={`flex items-center pt-0.5 font-['Helvetica_Neue',_Arial,_sans-serif] ${extraClass}`}>
      {cancellationType === 'free' && (
        <span className={lineClass}>
          <SafetyOutlined className="h-3.5 w-3.5 text-[#1f9d57]" />
          Free cancellation
        </span>
      )}

      {cancellationType === 'partial' && (
        <span className={lineClass}>
          <SafetyOutlined className="h-3.5 w-3.5 text-[#1f9d57]" />
          Partial refund
        </span>
      )}

      {cancellationType === 'non-refundable' && (
        <span className={lineClass}>
          <ShieldOffIcon />
          Non-refundable
        </span>
      )}
    </div>
  );
}
